import Vue from 'vue'
import Popup from '@/component/popup/popup'
import router from '@/router'

const PopupClass = Vue.extend(Popup)

const Vnode = Vue.extend(Vue.component('vnode', {
    functional: true,
    props: ['node'],
    mounted() {
    },
    render: function (h, ctx) {
        return this.node
    }
}))

Vue.mixin({
    methods: {
        $dialog(component, options = {}) {
            return new Promise((resolve, reject) => {
                let div = document.createElement('div')
                let context = this.$createElement(component || 'div', {
                    props: options.data || {}
                })
                let popup = new PopupClass({
                    el: div,
                    router,
                    propsData: {
                        ...options,
                        beforeClose: async () => {
                            if (typeof context?.componentInstance?.beforeClose == 'function') {
                                return await context.componentInstance.beforeClose()
                            }
                        }
                    },
                })
                popup.$slots.default = [context]
                let close = () => {
                    this.$nextTick(() => {
                        popup.$el.remove()
                        popup.$destroy()
                    })
                }
                popup.$on('cancel', () => {
                    close()
                    reject()
                })
                popup.$on('confirm', (e) => {
                    close()
                    resolve(e)
                })
                document.body.appendChild(popup.$el)
                popup.open()
            })
        },
        $launch(component, data) {
            let div = document.createElement('div')
            let cmp = this.$createElement(component, {
                props: data
            })
            let instance = new Vnode({
                el: div,
                propsData: {
                    node: cmp
                }
            })
            document.body.append(instance.$el)
            return {
                destory() {
                    instance.$destroy()
                    instance.$el.remove()
                },
                get instance() {
                    return cmp.componentInstance
                }
            }
        }
    }
})